const setProviders = (state, providers) => (state.providers = providers);

const setProvidersWithoutPagination = (state, ProvidersWithoutPagination) =>
  (state.ProvidersWithoutPagination = ProvidersWithoutPagination);

let mutations = {
  setProvidersWithoutPagination,
  setProviders
};

export default mutations;
